//电站列表
export const SELECT_DEVICE_TYPE='home/devicetypelist/SELECT_DEVICE_TYPE';
